// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1EoZg","topBottomGutter":"Layout_topBottomGutter__VhAlu"};